import { observer } from "mobx-react-lite";

import { translateDayLabel } from "../../common/utils";
import { formatDateTime, formatDeliveryDate } from "../../common/utils/dateUtils";

import cartStore from "../../stores/cart/cartStore";
import deliveryDatesStore from "../../stores/deliveryDates/deliveryDatesStore";
import theme from "../../themes/theme";

import MiniCartInfoLine from "./MiniCartInfoLine";

const MiniCartDates = () => (
   <div className="w-full">
      <div className="px-1 @[575px]:px-2">
         <MiniCartInfoLine
            margin
            label="Bestillingsfrist"
            value={formatDateTime(deliveryDatesStore.getCurrentDelivery()?.deadline, true, true)}
         />
         <MiniCartInfoLine
            margin
            label={translateDayLabel(cartStore.orderType, theme.deliveryMethod)}
            value={formatDeliveryDate(
               deliveryDatesStore.getCurrentDelivery()?.date,
               cartStore.orderType,
               deliveryDatesStore.getCurrentDelivery()?.interval
            )}
         />
      </div>
   </div>
);

export default observer(MiniCartDates);
